export default {
  picks: {
    title: "Le mie scelte",
    actions: {
      selectLocation: "Seleziona una località",
      importPhoto: "Importa foto",
      takePhoto: "Scatta foto",
      selectOperatorToContinue: "Seleziona un operatore per continuare",
      openOn: "Apri su {{operator}}",
      visit: "Visita {{operator}}",
    },
    locationGate: {
      title: "Consenti a Linemate di accedere alla tua posizione per usare Le mie scelte",
      subtitle: "Linemate usa la tua posizione per mostrare mercati e offerte disponibili nella tua zona.",
    },
    empty: {
      title: "Ancora nessuna scelta",
      subtitle: "Tocca un trend per aggiungerlo, oppure condividi una foto e prenderemo noi le scelte per te.",
    },
    imageImport: {
      title: "Importa scelte",
      scanningBetslip: "Scansione betslip...",
      analyzingImage: "Analisi immagine...",
      detectingOdds: "Rilevamento quote",
      failed: "Importazione scelte non riuscita",
      pleaseTryAgain: "Riprova",
      tryAgain: "Riprova",
    },
    labels: {
      parlay: "Parlay",
      sgp: "SGP",
      straight: "Singola",
      legParlay: "Parlay da {{count}} leg",
      pricingUnavailable: "Prezzo non disponibile",
      continueToOperator: "Continua verso il tuo operatore",
    },
    sections: {
      availableOrAdjusted: "Tutte le props disponibili o aggiustate",
      missingProps: "Props mancanti",
      unavailableInRegion: "Non disponibile nella tua regione",
    },
    warnings: {
      legsNotFound_one: "{{count}} leg non trovata",
      legsNotFound_other: "{{count}} leg non trovate",
      adjusted_one: "{{count}} leg è stata aggiustata",
      adjusted_other: "{{count}} leg sono state aggiustate",
      and: " e ",
      forOperator: " per {{operator}}.",
    },
  },
};